import { LoadableRoute } from 'routes/utils/loadable';

export const PublicSharedListContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "PublicSharedList" */ './PublicSharedList'),
});
